// product hover
if (document.querySelectorAll('.collection-default-page .grid__item').length) {
  initProductHover();
  window.addEventListener('reinitProductHover', function() {
    if (document.querySelectorAll('.collection-default-page .grid__item').length) {
      initProductHover();
    }
  });
}

function initProductHover() {
  const gridItems = document.querySelectorAll('.collection-default-page .grid__item');
  
  // Remove existing event listeners
  gridItems.forEach(item => {
    const newItem = item.cloneNode(true);
    item.parentNode.replaceChild(newItem, item);
  });
  
  // Add new hover event listeners
  document.querySelectorAll('.collection-default-page .grid__item').forEach(item => {
    item.addEventListener('mouseenter', function(e) {
      if (window.innerWidth > 1298 && document.querySelectorAll('.row-view').length === 0) {
        this.style.height = this.offsetHeight + 'px';
        this.classList.add('hovered');
      }
    });
    
    item.addEventListener('mouseleave', function() {
      if (window.innerWidth > 1298 && document.querySelectorAll('.row-view').length === 0) {
        this.style.height = '';
        this.classList.remove('hovered');
      }
    });
  });
}

// Update product image on click color
document.addEventListener('click', function(e) {
  if (e.target.closest('.product-colors-swatch')) {
    const swatch = e.target.closest('.product-colors-swatch');
    const newImage = swatch.dataset.img;
    const variantId = swatch.dataset.variantId;
    const card = swatch.closest(".card-wrapper");
    
    if (card) {
      // Update image
      const productImage = card.querySelector(".card--product img");
      if (productImage && newImage) {
        productImage.srcset = newImage;
      }
      
      // Update anchor link
      const anchor = card.querySelector(".card__inner a");
      if (anchor && variantId) {
        let href = anchor.getAttribute("href");
        
        if (href.includes("?variant=")) {
          href = href.replace(/variant=\d+/, "variant=" + variantId);
        } else {
          href += (href.includes("?") ? "&" : "?") + "variant=" + variantId;
        }
        
        anchor.setAttribute("href", href);
      }
    }
  }
});


// PDP thumbnail slider
$(document).ready(function () {
  $('.product-thumbnail-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1
  });
});

// PDP gallery mobile slider
if ($(window).width() < 749) {
  $(document).ready(function () {
    var $pdpMobileSlider = $('.product-mobile-slider');

    if (!$pdpMobileSlider.hasClass('slick-initialized')) {
      $pdpMobileSlider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true
      });
    }

    $('.swatch-element.color .color-swatch').on('click', function () {
      var selectedConnect = $(this).data('connect'); // Use data-connect
      var targetIndex = -1;

      $pdpMobileSlider.find('.product__media-item').each(function () {
        var slideConnect = $(this).data('connect'); // Use data-connect
        var slickIndex = $(this).attr('data-slick-index');

        if (String(slideConnect) === String(selectedConnect)) {
          targetIndex = parseInt(slickIndex, 10);
          return false; // break loop
        }
      });

      if (targetIndex !== -1) {
        $pdpMobileSlider.slick('slickGoTo', targetIndex);
      } else {
        console.log('No matching slide found for connect key:', selectedConnect);
      }
    });
  });
}

// PDP Tabs
document.querySelectorAll('.nav-tabs li a').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    document.querySelectorAll('.nav-tabs li').forEach(function(li) {
      li.classList.remove('active');
    });

    document.querySelectorAll('.tab-pane').forEach(function(tab) {
      tab.classList.remove('active');
    });

    const target = this.getAttribute('href');
    
    this.closest('li').classList.add('active');
    document.querySelector(target).classList.add('active');
  });
});

document.querySelectorAll('.accordion__anchor').forEach(function(anchor) {
  anchor.addEventListener('click', function() {
    const index = this.dataset.index;

    document.querySelectorAll('.product-tabs-section .nav-tabs li').forEach(function(li) {
      li.classList.remove('active');
    });

    document.querySelectorAll('.product-tabs-section .tab-pane').forEach(function(tab) {
      tab.classList.remove('active');
    });

    document.querySelectorAll('.product-tabs-section .nav-tabs li, .product-tabs-section .tab-pane').forEach(function(el) {
      if (el.dataset.index == index) {
        el.classList.add('active');
      }
    });
  });
});

// Collection description read more
document.addEventListener('DOMContentLoaded', function () {
  const descriptions = document.querySelectorAll('.collection-description');

  descriptions.forEach(function (description) {
    const content = description.querySelector('.description-content');
    const readMoreLink = description.querySelector('.read-more');

    const fullText = content.innerHTML;
    const shortText = fullText.split(" ").slice(0, 70).join(" "); // Adjust word count as needed

    if (fullText.length > shortText.length) {
      content.innerHTML = shortText + '...';
      readMoreLink.style.display = 'inline';

      readMoreLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (readMoreLink.textContent === 'Read More') {
          content.innerHTML = fullText;
          readMoreLink.textContent = 'Read Less';
        } else {
          content.innerHTML = shortText + '...';
          readMoreLink.textContent = 'Read More';
        }
      });
    }
  });
});


// FAQs
$('.faq-question').on('click', function() {  
  $(this).next('.faq-answer').slideToggle(300);
});
document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    question.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });
});

// Sticky header
window.addEventListener('scroll', function() {
  const scroll = window.scrollY;
  const header = document.querySelector('sticky-header .header-sticky-wrap');
  if (header) {
    if (scroll > 100) header.classList.add('fixedbar');
    else header.classList.remove('fixedbar');
  }
});

// Cart page disable checkout button
/*
document.addEventListener('DOMContentLoaded', function () {
  const messageElements = document.querySelectorAll('.minimum-order-amount-not-met');
  const targetElements = document.querySelectorAll('.minimum-order-amount-content');

  const lastMessageEl = messageElements[messageElements.length - 1];
  const lastTargetEl = targetElements[targetElements.length - 1];

  if (lastMessageEl && lastTargetEl) {
    lastTargetEl.insertAdjacentHTML('beforeend', lastMessageEl.innerHTML);
    lastMessageEl.remove(); // Optional: remove original after moving

    document.querySelectorAll(".cart__ctas").forEach(function(el) {
      el.style.display = "none";
    });
  } else {
    document.querySelectorAll(".cart__ctas").forEach(function(el) {
      el.style.display = "";
    });
  }
});
*/

// Cart update button blink on input change
document.querySelectorAll('.cart input, textarea').forEach(function(element) {
  element.addEventListener('change', function() {
    const updateBtn = document.getElementById('update-cart');
    if (updateBtn) updateBtn.classList.add('blink-border');
  });
});

// Show header account dropdown
document.body.addEventListener('click', function(e) {
  const target = e.target;
  const accountIcon = target.closest('.header__icon--account');
  const closeBtn = target.closest('.dropdown-menu__close');
  const dropdown = document.querySelector('.account-dropdown-menu');

  if (accountIcon && dropdown) {
    dropdown.style.display = (dropdown.style.display === 'block' ? 'none' : 'block');
  }
  if (closeBtn && dropdown) {
    dropdown.style.display = 'none';
  }
});

// Modal close PDP
document.querySelectorAll('.modal-header .icon').forEach(function(icon) {
  icon.addEventListener('click', function(e) {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'auto';

    const modal = document.getElementById('modalAddToCart');
    if (modal) {
      modal.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
      modal.style.overflow = 'hidden';
      modal.style.opacity = '0';
      modal.style.maxHeight = '0';
      
      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);
    }
  });
});

// Follow quantity steps if enters manually
document.querySelectorAll('.qty-steps').forEach(input => {
  input.addEventListener('change', () => {
    const step = parseFloat(input.step) || 1;
    const min = parseFloat(input.min) || 0;
    let value = parseFloat(input.value);

    if (isNaN(value)) return;

    const remainder = (value - min) % step;
    value = remainder >= step / 2
      ? value + (step - remainder)
      : value - remainder;

    input.value = value;
  });
});

// PDP companion slider
$(document).ready(function () {

    $('.product-companion-inner').each(function () {
        const $slider = $(this);
        const count = parseInt($slider.attr('data-companion-count'), 10);

        const shouldInit = window.innerWidth < 749
            ? count > 1
            : count > 3;

        if (shouldInit && !$slider.hasClass('slick-initialized')) {
            $slider.slick({
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 749,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    });

});

// PDP zoom
function initZoom() {
  if ($(window).width() <= 992) return;

  if (typeof $.fn.ezPlus === 'undefined') {
    console.warn('ezPlus plugin not loaded');
    return;
  }

  var $img = $('.zoom_04');

  if (!$img.length) return;

  // Destroy previous instance
  if ($img.data('ezPlus')) {
    $img.ezPlus('destroy');
    $img.removeData('ezPlus');
    $('.zoomContainer').remove();
  }

  // Wait for image to fully load before initializing
  if ($img[0].complete) {
    startZoom($img);
  } else {
    $img.one('load', function () {
      startZoom($img);
    });
  }
}

function startZoom($img) {
  $img.ezPlus({
    gallery: 'Slider-Thumbnails-template--22165652602903__main',
    cursor: 'pointer',
    galleryActiveClass: 'active',
    imageCrossfade: true,
    loadingIcon: 'http://www.elevateweb.co.uk/spinner.gif'
  });
}

$(window).on('load', function () {
  initZoom();
});

$(document).on('click', '.color-swatch', function () {
  setTimeout(function () {
      initZoom();
  }, 300);
});
